import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import BootCampComponentList from '~/client/components/boot-camp-component-list/boot-camp-component-list';
import Breadcrumbs from '~/client/components/breadcrumbs/breadcrumbs';
import ContentContainer from '~/client/components/content-container/content-container';
import Layout from '~/client/components/layout/layout';
import PreviewCard from '~/client/components/preview-card/preview-card';
import type { BootCampConceptsLandingPage as Props } from './boot-camp-concepts-landing-page.types';

const BootCampConceptsLandingPage: React.FC<Props> = ({
  breadcrumbs,
  concepts,
  layout,
  title,
}) => (
  <Layout {...layout}>
    <div className="boot-camp-concepts-landing-page">
      <Breadcrumbs {...breadcrumbs} />
      <div className="boot-camp-concepts-landing-page__header">
        <ContentContainer theme={ContentContainer.themes.wide}>
          <Text theme={Text.themes.headline} size={Text.sizes.headline2} italic>
            {title}
          </Text>
        </ContentContainer>
      </div>
      <ContentContainer theme={ContentContainer.themes.wide} raw>
        <div className="boot-camp-concepts-landing-page__inner">
          <BootCampComponentList {...concepts} entryRenderer={PreviewCard} />
        </div>
      </ContentContainer>
    </div>
  </Layout>
);

export default BootCampConceptsLandingPage;
